import React, {Component, createRef} from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import {NavLink, withRouter} from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { Facebook, Twitter } from 'react-sharingbuttons'
import 'react-sharingbuttons/dist/main.css'
import { Helmet } from 'react-helmet'
import './PatternDetails.css';
import placeholderImage from '../../assets/images/placeholder-img-2.png';
import Moment from "react-moment";
import Spinner from "react-bootstrap/Spinner";
import UserButton from "../UI/UserButton/UserButton";
import apiUrl from "../../shared/config";
import PatternLoadFail from "../PatternLoadFail/PatternLoadFail";
import ExampleGame from "../ExampleGame/ExampleGame";
import SuggestExampleGame from "../ExampleGame/SuggestExampleGame/SuggestExampleGame";
import {motion, AnimatePresence} from "framer-motion";
import PatternVote from "../PatternVote/PatternVote";
import FadingList from "../FadingList/FadingList";
import {Edit, KeyboardArrowUp, KeyboardArrowDown, VisibilityOff} from "@material-ui/icons";
import PatternComment from "../PatternComment/PatternComment";
import AddPatternComment from "../PatternComment/AddPatternComment/AddPatternComment";
import PresetModal from "../UI/Modal/PresetModal/PresetModal";
import NewPatternComment from "../PatternComment/NewPatternComment/NewPatternComment"
import ImageWithFallback from "../UI/ImageWithFallback/ImageWithFallback";
import {Tooltip} from "@material-ui/core";
import {formatParagraphs, number_to_icon, validStringField} from "../../utils/utils";
import ResizableIframe from "../UI/ResizableIframe/ResizableIFrame";
import {RelatedPattern} from "../RelatedPattern/RelatedPattern";
import SuggestedExercise from "../SuggestedExercise/SuggestedExercise";
import Condition from "../Condition/Condition";
import Constraint from "../Constraint/Constraint";
import Consequence from "../Consequence/Consequence";
import MergedPatterns from "../MergedPatterns/MergedPatterns";
import PatternStateIcon from "../PatternStateIcon/PatternStateIcon";
import {getEditLock, LockResponses, LockType, overrideEditLock} from "../../utils/lockUtils";
import InfoButton from "../IconButtons/InfoButton/InfoButton";

import ReactHtmlParser from "react-html-parser";
import classes from "../Navigation/NavigationItems/NavigationItem/NavigationItem.module.css";

// import mergedIcon from '../../assets/images/merged_icon_default.svg';


class PatternDetails extends Component {
    state = {
        pattern: null,
        fetchedComments: [],
        displayedCommentsStart: 0,
        displayedCommentsEnd: 0,
        totalCommentCount: 0,
        fetchTimestamp: 0,
        shouldGetPattern: false,
        observer: null,
        gamesList: [],
        readyToLoadComments: 1,
        scrollTimeoutId: 0,
        scrollIntervalId: 0,
        topOfPage: false,
        bottomOfPage: false,
        startedUpdating: false,
        manager: false,
        // windowWidth: 0,
    };

    //topOfPage = createRef()
    overrideModal = createRef();


    componentDidMount() {
        if (this.props.id && (!this.props.urlId || this.props.id === this.props.urlId)) {
            // When the PatternDetails mount, only fetch the pattern if the props contains an id, and either the URL
            // doesn't contain an id or the URL contains the same id as the selected id. Otherwise, fetching the
            // pattern will be handled on update
            let url = apiUrl +'Pattern/getbyid';
            let params = {
                params: {
                    pattern_id: this.props.id,
                    token: this.props.token
                }
            }
            // console.log('RERENDER ERROR');
            if (!this.state.startedUpdating) {
            axios.get(url, params)
                .then(response => {
                    this.setState({pattern: response.data});
                }).then(() => {
                    document.title = 'Pattern Library: '+this.state.pattern.title;
                }).then(() => {this.handleFetchComments(10, "New")
                }).then(() => setTimeout(() => window.scrollTo({
                    top: document.getElementById('pattern-details').offsetTop,
                    behavior: 'smooth'
                    }), 100))
                axios.get(apiUrl + 'Games/getGames')
                    .then(response => {
                        const list = response.data.map(game => ({
                            value: game.game_id,
                            label: game.game_name
                        }))
                        this.setState({gamesList: list});
                    })
                    .catch(error => {
                        console.error('Error fetching games:', error);
                    });
            }


        }
        else if (this.state.pattern && this.props.id === null) {
            this.setState({pattern: null});
        }
        // console.log(this.state)

        // window.addEventListener('resize', () => {
        //     if (this.state.windowWidth !== window.innerWidth) {
        //         this.setState({windowWidth: window.innerWidth});
        //     }
        // })
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        window.dispatchEvent(new Event('resize')); // we are using this to make sure when an element moves after rating the rating box moves with it
        if (!this.state.startedUpdating) {
            this.setState({startedUpdating: true});
        }

        if (this.state.shouldGetPattern) {
            const url = apiUrl +'Pattern/getbyid';
            const params = {
                params: {
                    pattern_id: this.props.id ?? this.state.pattern.pattern_id,
                    token: this.props.token
                }
            }

            axios.get(url, params)
                .then(response => {
                    this.setState({pattern: response.data});
                });
            this.setState({shouldGetPattern: false})
        }

        if (this.props.id && this.props.id !== prevProps.id) {
            if (!this.state.pattern || (this.state.pattern && this.state.pattern.pattern_id !== this.props.id)) {
                const url = apiUrl + 'Pattern/getbyid';
                const params = {
                    params: {
                        pattern_id: this.props.id,
                        token: this.props.token
                    }
                }
                axios.get(url, params)
                    .then(response => {
                        this.setState({pattern: response.data});
                        setTimeout(() => window.scrollTo({
                            top: document.getElementById('pattern-details').offsetTop,
                            behavior: 'smooth'
                        }), 100)
                    })
                    .then(() => {this.handleFetchComments(10, "New")});

                axios.get(apiUrl + 'Games/getGames')
                    .then(response => {
                        const list = response.data.map(game => ({
                            value: game.game_id,
                            label: game.game_name
                        }))
                        this.setState({gamesList: list});
                    })
                    .catch(error => {
                        console.error('Error fetching games:', error);
                    });

            }
        }
        else if (this.state.pattern && this.props.id === null && prevProps.id !== null) {
            this.setState({pattern: null, totalCommentCount: 0});
        }

        let comments_list = document.getElementById("comments-list");
        // If there is a comment list scroll box currently rendered, add a listener to it
        if (comments_list) {
            let prevScrollTop = 0

            this.determinePageTopAndBottom(comments_list);

            // If readyToLoadComments === -1, the comment box should scroll to the top
            // @TODO turn readyToLoadComments into an enum
            if (this.state.readyToLoadComments === -1) {//} || (Math.abs(comments_list.scrollHeight - comments_list.clientHeight - comments_list.scrollTop) <= 1 && comments_list.scrollTop <= 1 && (!this.state.topOfPage || !this.state.bottomOfPage))) {
                comments_list.scrollTo(0, 0);
                this.setState({readyToLoadComments: 0});
            }


            // Add a scroll listener
            comments_list.addEventListener("scroll", (evt) => {
                // console.log("scroll height" + comments_list.scrollHeight)
                // console.log("client height" + comments_list.clientHeight)
                // console.log("scroll top" + comments_list.scrollTop)

                if (Math.abs(evt.target.scrollHeight - evt.target.clientHeight - evt.target.scrollTop) <= 1  // Scrollbar is at the bottom of the box
                        && evt.target.scrollTop > prevScrollTop  // Scrollbar is moving down
                        && this.state.displayedCommentsEnd !== this.state.totalCommentCount  // The last comment being displayed isn't the last comment under the pattern
                        && this.state.readyToLoadComments) // The box is ready to load more comments
                {
                    this.setState({readyToLoadComments: 0})    // Make it so the box no longer ready to load more comments
                    this.loadMoreComments(5); // Load the next 5 comments
                }
                else if (evt.target.scrollTop <= 1  // Scrollbar is at the top of the page
                        && this.state.readyToLoadComments   // Box is ready to load more comments
                        && evt.target.scrollTop < prevScrollTop // Scrollbar is moving up
                        && this.state.displayedCommentsStart !== 0) // The first comment being displayed isn't the first comment under the pattern
                {
                    // When evt.target.scrollTop is 0, the scroll bar "sticks" to the top. This means that changing
                    // the displayed comments will automatically shift the scrollbar to the top. I'm not sure why
                    // this happens, so I did a small fix that shifts the scrollbar slightly down before
                    // changing the displayed comments
                    if (evt.target.scrollTop < 1) {
                        comments_list.scrollBy(0, 1);
                    }
                    this.setState({readyToLoadComments: 0}); // Make it so the box no longer ready to load more comments
                    this.loadMoreComments(-5);  // Load the previous 5 comments
                }
                else if (!this.state.readyToLoadComments    // Box isn't ready to load more comments
                            && evt.target.scrollTop > 0.5     // Scrollbar isn't at the top of the page
                            && Math.abs(evt.target.scrollHeight - evt.target.clientHeight - evt.target.scrollTop) > 1) // Scrollbar isn't at the bottom of the page
                {
                    // This case handles debouncing
                    this.setState({readyToLoadComments: 1});    // Make the box ready to load more comments
                }
                prevScrollTop = evt.target.scrollTop;   // Set prevScrollTop to the current scrollTop to check the direction the scrollbar is moving

                this.determinePageTopAndBottom(comments_list);
            })
        }
    }

    determinePageTopAndBottom(commentsList) {
        if (commentsList.scrollTop < 0.5 && this.state.displayedCommentsStart === 0 && !this.state.topOfPage) {
            this.setState({topOfPage: true})
        } else if ((commentsList.scrollTop >= 0.5 || this.state.displayedCommentsStart !== 0) && this.state.topOfPage) {
            this.setState({topOfPage: false})
        }
        if (this.state.displayedCommentsEnd === this.state.totalCommentCount && Math.abs(commentsList.scrollHeight - commentsList.clientHeight - commentsList.scrollTop) < 1 && !this.state.bottomOfPage) {
            this.setState({bottomOfPage: true})
        } else if ((this.state.displayedCommentsEnd !== this.state.totalCommentCount || Math.abs(commentsList.scrollHeight - commentsList.clientHeight - commentsList.scrollTop) >= 1) && this.state.bottomOfPage) {
            this.setState({bottomOfPage: false})
        }
    }

    /**
     * Extracts pattern_game_user_ids and pattern_secondary_game_user_ids without repeats
     * @param patternData pattern data.
     * @returns {any[]}
     */
    extractUniqueUserIds(patternData) {
        const userIds = new Set();

        if (patternData.example_games) {
            // Iterate through example games
            patternData.example_games.forEach(game => {
                // Add the primary pattern_game_user_id if not already present
                userIds.add(game.pattern_game_user_id);

                // Iterate through secondary games to add pattern_secondary_game_user_id
                game.secondary_games.forEach(secondaryGame => {
                    userIds.add(secondaryGame.pattern_secondary_game_user_id);
                });
            });
        }

        // Convert Set to Array
        return Array.from(userIds);
    }



    handleFetchComments(quantity, fetch_flag, shift, shiftBaseCommentId) {
        const url = apiUrl +'Pattern/getCommentList';
        let params = {
            params: {
                pattern_id: this.props.id ?? this.state.pattern.pattern_id,
                quantity: quantity,
                offset: (fetch_flag === "Load" ? this.state.fetchedComments.length : 0),
                token: this.props.token || null
            }
        }

        axios.get(url, params)
            .then(response => {
                // console.log(this.state.fetchedComments)
                // console.log(response.data.comments)
                switch (fetch_flag) {
                    case 'Load':
                        if (this.state.totalCommentCount === response.data.comment_count
                                    && this.state.fetchTimestamp > new Date(response.data.recent_timestamps.recent_posted_timestamp).getTime()
                                    && this.state.fetchTimestamp > new Date(response.data.recent_timestamps.recent_edited_timestamp).getTime()) {
                            // If the comments in the database haven't changed since the last fetch, append the comments
                            // that were just fetched to the end of fetchedComments, then load the next comment block
                            let newDisplayEnd = Math.min(this.state.displayedCommentsEnd + shift, this.state.totalCommentCount);
                            let newDisplayStart = newDisplayEnd - 10;
                            this.setState({
                                fetchedComments: this.state.fetchedComments.concat(response.data.comments),
                                totalCommentCount: response.data.comment_count,
                                displayedCommentsEnd: newDisplayEnd,
                                displayedCommentsStart: newDisplayStart,
                                readyToLoadComments: 0,
                                fetchTimestamp: Date.now(),
                            })
                        } else {
                            // Database changed since last fetch. Reload
                            this.handleFetchComments(this.state.fetchedComments.length + 10, "Reload", shift, shiftBaseCommentId);
                        }
                        break;
                    case 'Reload':
                        // Database was updated since the last fetch. Reload the comments, but try to shift the comments
                        // so that they stay in the same relative place when displayed on the screen
                        const newBaseIndex = response.data.comments.findIndex((comment) => shiftBaseCommentId === comment.comment_id)
                        const currBaseIndex = this.state.fetchedComments.findIndex((comment) => shiftBaseCommentId === comment.comment_id)
                        let baseShift = shift;
                        if (newBaseIndex >= 0 && currBaseIndex >= 0) {
                            baseShift += newBaseIndex - currBaseIndex;
                        }
                        const newDisplayStart = Math.max(0, Math.min(response.data.comments.length, this.state.displayedCommentsStart + baseShift));
                        const newDisplayEnd = Math.min(response.data.comments.length, newDisplayStart + 10)
                        this.setState({
                            fetchedComments: response.data.comments,
                            displayedCommentsStart: newDisplayStart,
                            displayedCommentsEnd: newDisplayEnd,
                            totalCommentCount: response.data.comment_count,
                            readyToLoadComments: 0,
                            fetchTimestamp: Date.now()
                        });
                        break;
                    case 'New':
                        // Load the comments from the top. Happens when a pattern opens, or when a user
                        // adds a new comment
                        this.setState({
                            fetchedComments: response.data.comments,
                            displayedCommentsEnd: Math.min(response.data.comments.length, 5),
                            displayedCommentsStart: 0,
                            totalCommentCount: response.data.comment_count,
                            readyToLoadComments: -1,
                            fetchTimestamp: Date.now(),
                        });
                        break;
                    default:
                        // Default case: shouldn't be called
                        //console.log('Default case')
                        break;
                }
            });
    }

    isAtPageBottom(newDisplayEnd, comment_count) {
        let comments_list = document.getElementById("comments-list")
        return newDisplayEnd === comment_count && comments_list && Math.abs(comments_list.scrollHeight - comments_list.clientHeight - comments_list.scrollTop) < 1
    }

    isAtPageTop(newDisplayStart) {
        let comments_list = document.getElementById("comments-list")
        return newDisplayStart === 0 && comments_list && comments_list.scrollTop < 0.5
    }

    loadMoreComments(shift) {
        if (shift > 0) { // If shifting down (loading the next few comments)
            let newEnd = Math.min(shift + this.state.displayedCommentsEnd, this.state.totalCommentCount);
            if (newEnd - this.state.displayedCommentsStart > 10  // Shifting only the end would go over maximum display size
                    && newEnd !== this.state.displayedCommentsEnd) // The new display range ending index isn't the same as the current one
            {
                if (this.state.fetchedComments.length < this.state.totalCommentCount){ // Not all the pattern's comments have been fetched yet
                    // Fetch more comments and shift the display range
                    this.handleFetchComments(10, "Load", shift, this.state.fetchedComments[Math.min(Math.max(0, this.state.displayedCommentsEnd - 1), this.state.fetchedComments.length - 1)].comment_id)
                } else { // Just shift the display range
                    this.setState({
                        displayedCommentsEnd: newEnd,
                        displayedCommentsStart: Math.max(0, newEnd - 10),
                        readyToLoadComments: 0,
                    })
                }

            } else if (newEnd !== this.state.displayedCommentsEnd) { // The new display range ending index isn't the same as the current one
                // Just shift the display ending index
                this.setState({displayedCommentsEnd: newEnd, bottomOfPage: this.isAtPageBottom(newEnd, this.state.totalCommentCount)})
            }
        } else { // If shifting up (loading the previous few comments)
            let newStart = Math.max(shift + this.state.displayedCommentsStart, 0);
            if (this.state.displayedCommentsEnd - newStart > 10 // Shifting only the start would go over maximum display size
                    && newStart !== this.state.displayedCommentsStart) // The new display range starting index isn't the same as the current one
            {
                // Shift the display range
                this.setState({
                    displayedCommentsEnd: Math.min(newStart + 10, this.state.totalCommentCount),
                    displayedCommentsStart: newStart,
                    readyToLoadComments: 0,
                })
            } else if (newStart !== this.state.displayedCommentsStart) { // The new display range starting index isn't the same as the current one
                // Just shift the display starting index
                this.setState({displayedCommentsStart: newStart, topOfPage: this.isAtPageTop(newStart)})
            }
        }

    }


    deletePostHandler = () => {
        axios.get(apiUrl +'Pattern/delete?pattern_id=' + this.props.id + '&token=' + this.props.token)
            .then(response => {
                //console.log("Pattern Deleted")
                this.props.closePatternDetails(null)
            });
    };

    requestEdit(pattern_id) {
        getEditLock(this.props.token, pattern_id, LockType.PATTERN).then(response => {
            //console.log(response);
            if (response === LockResponses.LOCK_EXISTS) {
                this.overrideModal.current.open();
            } else if (response === LockResponses.LOCK_CREATED) {
                this.props.editPattern(pattern_id);
                this.props.closePatternDetails()
            }
            // it shouldn't return any other case other than a fail but might be worth coming back and adding it later.
        })
            .catch(() => console.log("Edit Failed due to inability to retrieve lock"))
    }

    overrideLock(pattern_id) {
        overrideEditLock(this.props.token, pattern_id, LockType.PATTERN)
            .then(response => {
                //console.log(response);
                if (response === LockResponses.LOCK_CREATED) {
                    this.props.editPattern(pattern_id);
                    this.props.closePatternDetails(null);
                }
            })
            .catch(() => console.log("Edit Failed due to inability to override lock"))
    }

    handleOverride(id) {
        this.overrideLock(id)
        this.overrideModal.current.close();
    }

    editPatternHandler = (selectedGameId) => {
        this.requestEdit(selectedGameId);
    };

    failMessage = (error_flag) => {
        switch(error_flag) {
            case 'ID_NOT_AN_INTEGER':
            case 'PATTERN_DOESNT_EXIST':
                return "You are looking for a pattern that doesn't exist. Make sure your URL ends with a valid integer value. " +
                    "It is recommended to navigate the Pattern Library using the Pattern Search Bar.";
            case 'PRIVATE_PATTERN':
                return "Your account does not have access to this pattern." +
                    " If you think you should have access to view this pattern, or you would like the pattern to be published," +
                    " contact the pattern authors."
            case 'NOT_LOGGED_IN':
                return "The pattern you are looking for is unpublished. If you think you should have access to view this pattern, " +
                    "you may have to log in to the Pattern Library."
            default:
                return "An error occurred while retrieving this pattern. If you think this is bug with the website, please " +
                    "contact the website administrators."
        }
    }


    render () {
        //console.log(this.state.pattern.title);
        if (this.state.pattern && this.state.pattern.message){ //&& this.state.pattern.title === null) {
            const failM = "This Pattern Request Has Failed";
            const failB = this.failMessage(this.state.pattern.message)
            // const failB = "This means that that your account does not have access to this pattern"
            //     + ", or the pattern does not exist. Ensure you are logged in and have access to the right group"
            //     + " to view this pattern.";
            return <PatternLoadFail failMessage={failM} failInfo={failB} />;
        } else {

            let pattern = <div className="d-flex justify-content-xl-center">
                <div className="alert alert-secondary text-center select-alert" role="alert">
                    Please select a Pattern to view.
                </div>
            </div>;
            if (this.props.id && !this.state.pattern && this.props.patternDetailsOpen) {
                pattern = <div className="d-flex justify-content-xl-center loading-alert">
                    <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        <span> Loading...</span>
                    </Button>{' '}
                </div>;
            }

            if (this.state.pattern && this.props.patternDetailsOpen) {
                // console.log('PATTERN: ',this.state.pattern);
                // UPDATE AUTHORS AND GROUPS TO WORK LIKE KEYWORDS
                const authors = this.state.pattern.authors ? this.state.pattern.authors.map(author => (
                    <UserButton userId={author.user_id} key={author.user_id} display_name={author.display_name}/>)) : '';
                const groups = this.state.pattern.groups.map(group => {
                    return (
                        <div
                            key={group.group_id}
                            className={"clickable"}
                            onClick={() => {
                                //this.props.updateGroupsFilter([group.group_id]);
                                this.props.updatePage(0);
                                this.props.closePatternDetails(null);
                            }}>
                            {group.group_name}
                        </div>)
                });
                const keywords = this.state.pattern.keywords.map(keywords => {
                    return (
                        <OverlayTrigger
                            key={"overlay" + keywords.keyword_id}
                            trigger={['hover', 'focus']}
                            rootClose
                            //rootCloseEvent="hover-off"
                            placement='bottom'
                            overlay={<Popover id='pattern-keyword-description'>
                                <Popover.Title as="h3">{keywords.keyword}: Description</Popover.Title>
                                <Popover.Content className="keyword-description">
                                    {keywords.keyword_description}
                                </Popover.Content>
                            </Popover>}
                        >
                            <div
                                key={keywords.keyword_id}
                                className={keywords.keyword_type + " clickable"}
                                onClick={() => {
                                    this.props.updateKeywordsFilter([keywords.keyword_id]);
                                    this.props.updatePage(0);
                                    this.props.closePatternDetails(null);
                                }}>
                                {keywords.keyword}
                            </div>
                        </OverlayTrigger>)

                });
                const conditions = this.state.pattern.conditions.map(condition => {
                    return <Condition key={"pattern-condition-" + condition.condition_id} condition={condition}
                                       closePatternDetails={this.props.closePatternDetails}
                                       updateConditionsFilter={this.props.updateConditionsFilter}
                                       updatePage={this.props.updatePage}/>
                });
                const constraints = this.state.pattern.constraints.map(constraint => {
                    return <Constraint key={"pattern-constraint-" + constraint.constraint_id} constraint={constraint}
                                       closePatternDetails={this.props.closePatternDetails}
                                       updateConstraintsFilter={this.props.updateConstraintsFilter}
                                       updatePage={this.props.updatePage}/>
                });
                const consequences = this.state.pattern.consequences.map(consequence => {
                    return <Consequence key={"pattern-consequence-" + consequence.consequence_id} consequence={consequence}
                                       closePatternDetails={this.props.closePatternDetails}
                                       updateConsequencesFilter={this.props.updateConsequencesFilter}
                                       updatePage={this.props.updatePage}/>
                });
                const related_patterns = this.state.pattern.related_patterns.map((related_pattern, index) => {
                    return <RelatedPattern key={"RelatedPattern-" + index} patternSelected={this.props.patternSelected} related_pattern={related_pattern}/>
                });
                const related_patterns_wrapper = (<motion.dl><AnimatePresence initial={false}>{related_patterns}</AnimatePresence></motion.dl>);
                const example_games = this.state.pattern.example_games.map((pattern_games) => {
                    return (
                        <ExampleGame
                            pattern_games={pattern_games}
                            gameSelected={this.props.gameSelected}
                            token={this.props.token}
                            patternId={this.state.pattern.pattern_id}
                            patternEditedDate={this.state.pattern.pattern_edited_date}
                            update={() => this.setState({shouldGetPattern: true})}
                            userId={this.props.userId}
                            authors={this.state.pattern.authors.map(author => parseInt(author.user_id))}
                            key={pattern_games.pattern_id + "-pattern-game-" + pattern_games.game_id}
                            patternSelected={this.props.patternSelected}
                            allGames={this.state.pattern.example_games}
                            listOfGames={this.state.gamesList}
                            designProblems={this.state.pattern.design_problems}
                        />
                    )
                });
                const example_games_wrapper = (<motion.dl><AnimatePresence initial={false}>
                    {/*<FadingList fadeHeight={200} mutable={false} initialHeight={800}>*/}
                        {example_games}
                    {/*</FadingList>*/}
                </AnimatePresence>
                </motion.dl>);

                const suggested_exercises = this.state.pattern.suggested_exercises.map((suggested_exercises, index) => {
                    const suggested_exercise_key = "suggested-exercise-" + suggested_exercises.exercise_id + "-" + index;
                    return (
                        <SuggestedExercise key={suggested_exercise_key} suggested_exercises={suggested_exercises}/>
                    )
                });
                const suggested_exercises_wrapper = (<dl className="suggested-exercises" style={{marginBottom: "0px"}}>{suggested_exercises}</dl>);

                const add_comment_form = ( <AddPatternComment
                        pattern_id={this.state.pattern.pattern_id}
                        token={this.props.token}
                        userId={this.props.userId}
                        update={() => this.handleFetchComments(10,  "New")}
                    />
                )

                const displayed_comments = this.state.fetchedComments.slice(this.state.displayedCommentsStart, this.state.displayedCommentsEnd);
                const pattern_comments = displayed_comments.map((pattern_comment, index) => {
                        return (<PatternComment
                            key={"comment-box-" + pattern_comment.comment_id}
                            pattern_comment={pattern_comment}
                            pattern_id={this.state.pattern.pattern_id}
                            userId={this.props.userId}
                            token={this.props.token}
                            updateOnDelete={() => this.handleFetchComments(this.state.fetchedComments.length-1,   "Reload", -1, this.state.fetchedComments[Math.min(Math.max(0, index - 1), this.state.fetchedComments.length - 1)].comment_id)}
                            updateOnEdit={() => this.handleFetchComments(this.state.fetchedComments.length,   "Reload", 0, pattern_comment.comment_id)}
                            authorIds={this.state.pattern.authors.map(author => parseInt(author.user_id))}
                        />)
                });

                let comments_list = document.getElementById("comments-list")
                const load_more_comments =  (!this.state.topOfPage || !this.state.bottomOfPage)
                    ? <span style={{textAlign: "center", display: "table", margin: "0 auto"}}>
                        <KeyboardArrowUp
                            style={{
                                width: "50px",
                                height: "50px",
                                transform: "scaleX(1.3)",
                                color: this.state.topOfPage ? "lightgrey" : "black"
                            }}
                            onMouseEnter={
                                () => {
                                    if (this.state.scrollTimeoutId !== 0) {
                                        clearTimeout(this.state.scrollTimeoutId)
                                    }
                                    if (this.state.scrollIntervalId !== 0) {
                                        clearInterval(this.state.scrollIntervalId)
                                    }
                                    let timeoutID;
                                    timeoutID = setTimeout(() => this.setState({scrollIntervalId: setInterval(() => comments_list.scrollBy({
                                            left: 0,
                                            top: -2,
                                        }), 1)}), 1000);
                                    this.setState({scrollTimeoutId: timeoutID})
                                }
                            }
                            onMouseLeave={
                                () => {
                                    if (this.state.scrollTimeoutId !== 0) {
                                        clearTimeout(this.state.scrollTimeoutId)
                                    }
                                    if (this.state.scrollIntervalId !== 0) {
                                        clearInterval(this.state.scrollIntervalId)
                                    }
                                }
                            }
                            onClick={
                            () => {
                                if (this.state.scrollTimeoutId !== 0) {
                                    clearTimeout(this.state.scrollTimeoutId)
                                }
                                if (this.state.scrollIntervalId !== 0) {
                                    clearInterval(this.state.scrollIntervalId)
                                }

                                if (comments_list.clientHeight > comments_list.scrollTop) {
                                    this.setState({readyToLoadComments: 1})
                                    this.loadMoreComments(-5)
                                    setTimeout(() => comments_list.scrollBy({left: 0, top: -1 * comments_list.clientHeight, behavior: "smooth"}), 50)
                                } else {
                                    this.setState({readyToLoadComments: 1})
                                    comments_list.scrollBy({
                                        left: 0,
                                        top: -1 * comments_list.clientHeight,
                                        behavior: "smooth"
                                    })
                                }
                            }
                        } />
                        <KeyboardArrowDown
                            style={{
                                width: "50px",
                                height: "50px",
                                transform: "scaleX(1.3)",
                                color: this.state.bottomOfPage ? "lightgrey" : "black"
                            }}
                            onMouseEnter={
                                () => {
                                    if (this.state.scrollTimeoutId !== 0) {
                                        clearTimeout(this.state.scrollTimeoutId)
                                    }
                                    if (this.state.scrollIntervalId !== 0) {
                                        clearInterval(this.state.scrollIntervalId)
                                    }
                                    let timeoutID;
                                    timeoutID = setTimeout(() => this.setState({scrollIntervalId: setInterval(() => comments_list.scrollBy({
                                        left: 0,
                                        top: 2,
                                    }), 1)}), 1000);
                                    this.setState({scrollTimeoutId: timeoutID})
                                }
                            }
                            onMouseLeave={
                                () => {
                                    if (this.state.scrollTimeoutId !== 0) {
                                        clearTimeout(this.state.scrollTimeoutId)
                                    }
                                    if (this.state.scrollIntervalId !== 0) {
                                        clearInterval(this.state.scrollIntervalId)
                                    }
                                }
                            }
                            onClick={
                            () => {
                                if (this.state.scrollTimeoutId !== 0) {
                                    clearTimeout(this.state.scrollTimeoutId)
                                }
                                if (this.state.scrollIntervalId !== 0) {
                                    clearInterval(this.state.scrollIntervalId)
                                }

                                if (comments_list.clientHeight * 2 + comments_list.scrollTop > comments_list.scrollHeight) {
                                    this.setState({readyToLoadComments: 1})
                                    this.loadMoreComments(5)
                                    setTimeout(() => comments_list.scrollBy({left: 0, top: comments_list.clientHeight, behavior: "smooth"}), 50)
                                } else {
                                    this.setState({readyToLoadComments: 1})
                                    comments_list.scrollBy({
                                        left: 0, top: comments_list.clientHeight, behavior: "smooth"
                                    })
                                }
                            }}
                        />
                    </span>
                    : "";

                const no_comments_display = () => {
                    return (this.props.token
                        ? (<React.Fragment>
                            <dl className="comment-box-scrollbar"
                                id="first-to-comment"
                                style={{paddingRight: "6px", overflowY: "hidden"}}
                            >
                                <NewPatternComment
                                    key={"comment-box-empty"}
                                    pattern_id={this.state.pattern.pattern_id}
                                    userId={this.props.userId}
                                    token={this.props.token}
                                    update={() => this.handleFetchComments(10,  "New")}
                                />
                            </dl>
                        </React.Fragment>)
                        : "")}

                const pattern_comments_wrapper =
                    displayed_comments.length === 0
                        ? no_comments_display()
                        : (<React.Fragment>
                            <dl className="comment-box-scrollbar"
                                id="comments-list"
                                style={{
                                    paddingRight: (comments_list && comments_list.scrollHeight > comments_list.clientHeight)
                                        ? "2px" : "6px",
                                    overflowY: (comments_list && comments_list.scrollHeight > comments_list.clientHeight)
                                        ? "scroll" : "hidden"
                                }}
                            >
                                {pattern_comments}
                            </dl>
                            {load_more_comments}
                        </React.Fragment>);

                const authors_array = this.state.pattern.authors.map(author => parseInt(author.user_id));
                const canEdit = this.props.isAuthenticated && ((authors_array.includes(parseInt(this.props.userId)) || +this.props.permissions.edit_patterns === 1 || authors_array.length === 0))

                const pattern_state = <PatternStateIcon hasMerged={this.state.pattern.has_merged}
                                                       patternStateName={this.state.pattern.pattern_state_name}
                                                       pattern_id={this.state.pattern.pattern_id}
                                                       token={this.props.token}
                                                       isAuthor={canEdit}
                                                       reloadPattern={() => this.setState({shouldGetPattern: true})}
                />

                let pattern_image = this.state.pattern.pattern_image;
                if (pattern_image === '') {
                    pattern_image = placeholderImage;
                }

                const edit_icon = canEdit ?
                    (<Tooltip title={"Edit Pattern"} placement={"top"}><Edit
                        onClick={() => this.editPatternHandler(this.state.pattern.pattern_id)}
                        className={"big-edit-icon"}/>
                    </Tooltip>) :
                    // (this.props.isAuthenticated ?
                    // <img className="state-icon Merged" src={mergedIcon} alt="Merged"
                    //      onClick={() => this.props.mergeSelectionModal.open(
                    //          {id: null, name: null},
                    //          {id: this.state.pattern.pattern_id, name: this.state.pattern.pattern_name}
                    //      )}/> : '');
                ''

                //const edit_icon_pattern_state_wrapper = (<span style={{float: "right"}}>{edit_icon}   {pattern_state}</span>);
                const pattern_state_wrapper = (<span style={{float: "left"}}>{pattern_state}</span>);
                const edit_icon_wrapper = (<span style={{float: "right"}}>{edit_icon}</span>);
                //{pattern_state}

                const pattern_design_problems_wrapper = this.state.pattern.design_problems.map((design_problem, index) =>
                    <React.Fragment key={'design-problem-' + index}>
                        {index >= 1 ? <div style={{display: "inline", justifyContent: "center"}}>
                            <p className="design-problem-and-line"><span className="design-problem-and-line-span">and</span></p>
                        </div> : ''}
                        <span style={{display: "inline-flex"}}>
                            {this.state.pattern.design_problems && this.state.pattern.design_problems.length > 1
                                ? <div style={{minWidth: 40}}><div style={{scale: "1.3"}}>{number_to_icon((index + 1) + '')}</div></div>
                                : ''}
                            <div style={{whiteSpace: 'pre-wrap'}}>{ReactHtmlParser(design_problem.design_problem)}</div>
                        </span>
                    </React.Fragment>
                );

                let admin_controls = (
                    <Col>
                        <div className="delete-pattern">
                            <Button variant="outline-danger" size="sm" onClick={this.deletePostHandler}
                                    className="delete-pattern-button">Delete Pattern</Button>
                        </div>
                    </Col>);
                admin_controls = ((this.props.permissions && this.props.permissions.delete_patterns) ? admin_controls : <Col>
                    <div className="delete-pattern"></div>
                </Col>);

                // let edit_controls = (
                //     <Col>
                //         <div className="edit-pattern">
                //             <Button variant="outline-primary" size="sm"
                //                     onClick={() => this.editPatternHandler(this.state.pattern.pattern_id)}
                //                     className="edit-pattern-button"><Edit />      Edit Pattern</Button>
                //         </div>
                //     </Col>
                // );
                // //const authors_array = this.state.pattern.authors.map(author => parseInt(author.user_id));
                // edit_controls = (this.props.isAuthenticated && (authors_array.includes(parseInt(this.props.userId)) || authors_array.length === 0) ? edit_controls :
                //     <Col>
                //         <div className="edit-pattern"></div>
                //     </Col>);


                let access_controls = (
                    <Row>
                        {/*{edit_controls}*/}
                        {admin_controls}
                    </Row>
                );

                const patternUrl = 'https://patternlanguageforgamedesign.com/PatternLibraryApp/PatternLibrary/' + this.props.id;
                const shareText = 'Pattern Language for Game Design — Pattern Library: ' + this.state.pattern.pattern_name;

                pattern = (<>
                        <div className="card pattern-details" style={this.state.pattern.hidden_content ? {border: "3px solid #bf8888",  boxShadow: "0px 0px 10px 1px #bf8888"} : {}}>
                            <Helmet>
                                <title>{shareText}</title>
                                <meta property="og:site_name"
                                      content="Pattern Language for Game Design: Pattern Library"/>
                                <meta property="og:title" content={this.state.pattern.pattern_name}/>
                                <meta property="og:description" content={this.state.pattern.pattern_design_problem}/>
                                <meta property="og:type" content="website"/>
                                <meta property="og:url" content={patternUrl}/>
                                <meta property="og:image" content={pattern_image}/>
                            </Helmet>
                            {this.state.pattern.hidden_content ?
                                <h1 className="card-header" style={{
                                    fontSize: "36px",
                                    padding: "6px",
                                    color: "#bf8888",
                                    borderBottom: "1px solid #bf8888"
                                }}>Hidden Content <OverlayTrigger
                                    trigger={["hover", "focus"]}
                                    rootClose
                                    rootCloseEvent="click"
                                    placement='bottom'
                                    overlay={
                                        <Popover id='hidden-content-info' style={{maxWidth: 1000}}>
                                            <Popover.Title as="h3">Hidden Content</Popover.Title>
                                            <Popover.Content className="hidden-content">

                                                {authors_array.includes(parseInt(this.props.userId))
                                                    ? <>This pattern is hidden because you don't have a shared contact
                                                        email, nor do any of the other authors of this pattern.
                                                        <br/><br/>Add and share a valid contact email to make this
                                                        pattern visible to other users on the site. You can do this by
                                                        editing your User Profile, entering a valid contact
                                                        email, then click "Display Contact Email."</>
                                                    : this.props.permissions && this.props.permissions.delete_patterns
                                                        ? <React.Fragment>{"This pattern is hidden because none of the pattern authors have a shared contact email. " +
                                                            "\n\nTo make this pattern visible, users who have permission to edit patterns " +
                                                                "can verify this pattern by liking it. \n\nFirst, make sure " +
                                                                "you have a valid contact email and check \"Display Contact Email\" " +
                                                                "in your User Profile. Then, like this pattern to verify it. \n\n"}
                                                                <i>This pattern will remain verified until it is edited while none
                                                                    of its authors have a shared contact email.</i>
                                                            </React.Fragment>
                                                        : ""}
                                            </Popover.Content>
                                        </Popover>
                                    }
                                >
                                    <VisibilityOff style={{transform: "scale(1.2)", marginLeft: 3}}/>
                                </OverlayTrigger></h1>
                            : ''}
                            <h1 className="card-header" style={{
                                borderBottom: this.state.pattern.pattern_descriptive_title && "none",
                                paddingBottom: this.state.pattern.pattern_descriptive_title && "0px",
                                paddingTop: "6px",
                                display: "flex",
                                width: "100%",
                                justifyContent: 'space-between'
                            }}>{pattern_state_wrapper}{this.state.pattern.pattern_name}{edit_icon_wrapper}</h1>
                            {this.state.pattern.pattern_descriptive_title &&
                                <h1 className="card-header" style={{
                                    fontSize: "24px",
                                    paddingTop: "0px",
                                    color: "#505050"
                                }}>{this.state.pattern.pattern_descriptive_title}</h1>}

                            <div className="card-body">
                                <div className="card-text">
                                    <Container>
                                        <Row>
                                            <Col className="col-xl-6" style={{paddingLeft: 0, paddingRight: 0}}>
                                                <ImageWithFallback className="align-self-left col-xl-12"
                                                                   src={pattern_image}
                                                                   alt={this.state.pattern.pattern_image_description}
                                                                   fallbackSrc={placeholderImage}
                                                />
                                                <div
                                                    className="align-self-center image-caption col-xl-12">{this.state.pattern.pattern_image_description}</div>
                                                <div className="col-xl-12">
                                                    <PatternVote user_vote={this.state.pattern.user_vote}
                                                                 token={this.props.token}
                                                                 up_votes={this.state.pattern.up_votes}
                                                                 down_votes={this.state.pattern.down_votes}
                                                                 update={() => {
                                                                     this.setState({shouldGetPattern: true});
                                                                     this.props.votePattern();
                                                                 }}
                                                                 pattern_id={this.state.pattern.pattern_id}/>
                                                </div>
                                            </Col>
                                            <Col className="col-xl-6 pattern-general-info">
                                                <dl className="row">
                                                    <dt className="col-xl-4">Author(s):</dt>
                                                    <dd className="col-xl-8"><FadingList initialHeight={90}
                                                                                         mutable={false}>{authors}</FadingList>
                                                    </dd>
                                                    {groups && groups.length > 0 && <>
                                                        <dt className="col-xl-4">Groups(s):</dt>
                                                        <dd className="col-xl-8"><FadingList
                                                            initialHeight={90}>{groups}</FadingList>
                                                        </dd>
                                                    </>}
                                                    <dt className="col-xl-4">Pattern Confidence:</dt>
                                                    <dd className="col-xl-8">{this.state.pattern.pattern_confidence}</dd>
                                                    <dt className="col-xl-4">Created On:</dt>
                                                    <dd className="col-xl-8"><Moment
                                                        format="MMMM Do YYYY, h:mma">{this.state.pattern.pattern_created_date}</Moment>
                                                    </dd>
                                                    <dt className="col-xl-4">Edited On:</dt>
                                                    <dd className="col-xl-8"><Moment
                                                        format="MMMM Do YYYY, h:mma">{this.state.pattern.pattern_edited_date}</Moment>
                                                    </dd>
                                                    {this.state.pattern.exercise_name && validStringField(this.state.pattern.seed) &&
                                                        <>
                                                            <dt className="col-xl-4">Seed:</dt>
                                                            <dd className="col-xl-8" onClick={() => {this.props.exerciseSelected(this.state.exercise_id);}}>
                                                                <NavLink
                                                                    to={
                                                                    "/PatternLibraryApp/PatternExercises/" +
                                                                        this.state.pattern.exercise_id + "/" +
                                                                        (this.state.pattern.execution_id !== null ? this.state.pattern.execution_id : "0")
                                                                }
                                                                    exact={true}
                                                                    activeClassName=""
                                                                    >
                                                                    {this.state.pattern.exercise_name} —- {this.state.pattern.seed}
                                                                </NavLink>

                                                            </dd>
                                                        </>

                                                    }
                                                    {keywords && keywords.length > 0 && <>
                                                        <dt className="col-xl-4">Keywords:</dt>
                                                        <dd className="col-xl-8"><FadingList
                                                            initialHeight={80}>{keywords}</FadingList>
                                                        </dd>
                                                    </>}
                                                    {conditions && conditions.length > 0 &&
                                                        <>
                                                            <dt className="col-xl-12"
                                                                style={{marginBottom: 10}}>Conditions:
                                                                <InfoButton infoContent={{
                                                                    title: 'Pattern Conditions',
                                                                    text: 'These describe forces that indicate a pattern should be considered. ' +
                                                                          'These forces are not required for the pattern to function, merely that it may apply. ' +
                                                                          'These forces are inclusive, a pattern with with \'shooting\' and \'jumping\' conditions ' +
                                                                          'would be indicated for games that included either of these mechanics.'}}
                                                                />
                                                            </dt>
                                                            <dd className="col-xl-12"><FadingList
                                                                initialHeight={120}>{conditions}</FadingList></dd>
                                                        </>}
                                                    {constraints && constraints.length > 0 &&
                                                        <>
                                                            <dt className="col-xl-12"
                                                             style={{marginBottom: 10}}>Constraints:
                                                                <InfoButton infoContent={{
                                                                    title: 'Pattern Constraints',
                                                                    text: 'These are factors that MUST be present for the pattern to function. ' +
                                                                          'Constraints are subtractive, a pattern with a \'multiplayer\' constraint' +
                                                                          'would only apply to multi-player games and not single-player games.'}}
                                                                />
                                                            </dt>
                                                            <dd className="col-xl-12"><FadingList
                                                            initialHeight={120}>{constraints}</FadingList></dd>
                                                        </>}
                                                    {consequences && consequences.length > 0 &&
                                                        <>
                                                            <dt className="col-xl-12"
                                                                style={{marginBottom: 10}}>Consequences:
                                                                <InfoButton infoContent={{
                                                                    title: 'Pattern Consequences',
                                                                    text: 'These indicate follow-on effects of the pattern that exist in addition to the primary effect. ' +
                                                                          'Consequences can be positive or negative.'}}
                                                                />
                                                            </dt>
                                                            <dd className="col-xl-12"><FadingList
                                                                initialHeight={120}>{consequences}</FadingList></dd>
                                                        </>}
                                                </dl>
                                            </Col>
                                        </Row>
                                        <Row><Col>
                                            <dl className="row">
                                                <dt className="col-xl-2">Design Problem{this.state.pattern.design_problems.length > 1 ? 's' : ''}:</dt>

                                                <dd className="col-xl-10" style={{whiteSpace: "pre-wrap"}}>{pattern_design_problems_wrapper}</dd>
                                            </dl>
                                        </Col></Row>
                                        <Row><Col>
                                            <dl className="row">
                                                <dt className="col-xl-2">Pattern Description:</dt>
                                                <dd className="col-xl-10"
                                                    style={{whiteSpace: "pre-wrap"}}>{this.state.pattern.pattern_description && this.state.pattern.pattern_description.description
                                                    ? ReactHtmlParser(this.state.pattern.pattern_description.description) : ''}</dd>

                                            </dl>
                                        </Col></Row>
                                        {this.state.pattern.playable_concept && <Row><Col>
                                            <dl className="row">
                                                <dt className="col-xl-2">Playable Concept:</dt>
                                                <dd className="col-xl-10" style={{whiteSpace: "pre-wrap"}}>
                                                        <div className={'game-border'}>
                                                            <div
                                                                className={'game-title'}>{this.state.pattern.playable_concept.game_name}</div>
                                                            <div className={'game-body'}>
                                                                <Row style={{
                                                                    display: "flex",
                                                                    justifyContent: "center", // centers the iframe horizontally
                                                                    alignItems: "center", // vertically centers the iframe
                                                                    textAlign: "center",  // centers the text content
                                                                    flexDirection: "column", // ensures the iframe and link are stacked vertically
                                                                    gap: "10px",
                                                                    marginTop: "20px",
                                                                }} key={"embedded game"}>
                                                                    <ResizableIframe
                                                                        title={this.state.pattern.playable_concept.game_name}
                                                                        src={this.state.pattern.playable_concept.game_embed_link}
                                                                        failContent="Embeded Game Failed to Load"
                                                                    />
                                                                </Row>
                                                                <div style={{paddingInline: "10px", paddingBottom: 0}}>
                                                                    {formatParagraphs(this.state.pattern.playable_concept.description)}
                                                                </div>
                                                            </div>
                                                        </div></dd>
                                            </dl>
                                        </Col></Row>}
                                        <Row><Col>
                                            <dl className="row">
                                                <dt className="col-xl-2">Example Games:</dt>
                                                <dd className="col-xl-10">{example_games_wrapper}<AnimatePresence><SuggestExampleGame
                                                    lastEditDate={this.state.pattern.pattern_edited_date}
                                                    userId={this.props.userId} token={this.props.token}
                                                    listOfGames={this.state.gamesList}
                                                    pattern_id={this.state.pattern.pattern_id}
                                                    update={() => this.setState({shouldGetPattern: true})}
                                                    designProblems={this.state.pattern.design_problems}
                                                    patternGames={this.state.pattern.example_games}/></AnimatePresence>
                                                </dd>
                                            </dl>
                                        </Col></Row>
                                        {related_patterns && related_patterns.length > 0 && <Row><Col>
                                            <dl className="row">
                                                <dt className="col-xl-2">Related Patterns:</dt>
                                                <dd className="col-xl-10">{related_patterns_wrapper}</dd>
                                            </dl>
                                        </Col></Row>}
                                        {suggested_exercises && suggested_exercises.length > 0 && <Row><Col>
                                            <dl className="row">
                                                <dt className="col-xl-2">Suggested Exercises:</dt>
                                                <dd className="col-xl-10">{suggested_exercises_wrapper}</dd>
                                            </dl>
                                        </Col></Row>}
                                        <MergedPatterns mergedArr={this.state.pattern.merged} patternName={this.state.pattern.pattern_name} selectPattern={this.props.patternSelected}/>
                                        <hr style={{border: "none", borderTop: "2px solid black"}}/>
                                        <Row><Col>
                                            <dl className="row">
                                                <dt className="col-xl-2">{this.state.totalCommentCount} Comment{this.state.totalCommentCount === 1 ? "" : "s"}:</dt>
                                                <dd className="col-xl-10">{add_comment_form}{pattern_comments_wrapper}</dd>
                                                {/*{!this.state.shouldLoadMoreComments && this.state.comments.length <= 3 ? <dd className="col-xl-12">{load_more_comments}</dd> : ""}/!*scroll_load*!/*/}
                                            </dl>
                                        </Col></Row>
                                        <Row><Col>
                                            <dl className="row">
                                                <dt className="col-xl-2"></dt>
                                                <dd className="col-xl-10">
                                                    Share this pattern on
                                                    <Facebook url={patternUrl}/> or
                                                    <Twitter shareText={shareText} url={patternUrl}/>
                                                </dd>
                                            </dl>
                                        </Col></Row>
                                        {access_controls}
                                    </Container>
                                </div>
                            </div>
                        </div>
                        <PresetModal ref={this.overrideModal} buttonText='Override' title='Override Editing Lock?'
                                     body="Another user is currently editing this pattern. If you choose to override this lock you may be overriding someone else's changes. If you don't want to override their lock please try again later."
                                     onButtonPress={() => this.handleOverride(this.state.pattern.pattern_id)}></PresetModal>
                    </>
                );
            }

            return pattern;
        }
    }
}

export default withRouter(PatternDetails);